/**
 * HYBRID LOTTO mark — kept identical to the web app's Logo.tsx so the brand
 * does not drift between the site and the mini app. Letters are strokes rather
 * than <text>: Telegram's WebView on Android and iOS resolve fonts
 * differently, and the mark would otherwise shift between devices.
 */
export function Logo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label="HYBRID LOTTO"
    >
      <defs>
        <linearGradient id="hl-ball-grad-mini" x1="24" y1="22" x2="76" y2="78" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f6e08f" />
          <stop offset="1" stopColor="#c99b23" />
        </linearGradient>
      </defs>
      <path d="M50 3 90 26v48L50 97 10 74V26z" fill="#11141c" stroke="#d4af37" strokeWidth="4" />
      <circle cx="50" cy="50" r="27" fill="url(#hl-ball-grad-mini)" />
      <ellipse cx="39" cy="38" rx="8" ry="5" fill="#ffffff" opacity="0.32" transform="rotate(-30 39 38)" />
      <g stroke="#0b0d12" strokeWidth="5.4" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M36 40v20M36 50h11M47 40v20" />
        <path d="M57 40v20h9" />
      </g>
    </svg>
  )
}
